<template>
  <div v-show="data.hidden === false" class="col-sm-12 h-subscriber-checkBoxMargin">
    <div class="h-subscriber-inputLit" v-if="data.showName !== ''">
      <ejs-checkbox
        ref="checkAll"
        :checked="checkAllFlag"
        v-model="checkAllFlag"
        @change="checkAll"
        name="checkAll"
      ></ejs-checkbox>
      {{data.showName}}
    </div>
    <div class="h-subscriber-checkBoxBorder" id="upfCheckedId">
      <div v-for="(option, index) in this.data.options" :key="index">
        <ejs-checkbox
          :id="checkId+index"
          cssClass="h-subscriber-check h-subscriber-checkBoxCommonStyle"
          :ref="option.value"
          :label="option.showName"
          :name="data.name"
          :checked="checkBoxArr[option.value]"
          v-model="checkBoxArr[option.value]"
          @change="caculateChecks"
          :bitVal="option.value"
        />
        <div :id="show+index" style="display:none">
            <div class="row h-row-inputBox">
              <div class="col-sm-6 h-col-inputBox">
                <div>
                  <div class="h-inputLit">
                    <span class="h-red-code">*</span>
                    {{$t('NSMF.deployAlias')}}:
                  </div>
                  <input
                    type="text"
                    :class="['e-control', 'e-textbox', 'e-lib', 'e-input']"
                    v-model="aliasList[index]"
                    :placeholder='$t("NSMF.deployAlias")'
                    name="aliasCheck"
                    maxlength="30"
                    @blur="aliasCheckBulr"
                  />
                </div>
              </div>
              <div class="col-sm-6 h-col-inputBox">
                <div>
                  <div class="h-inputLit"><span class="h-red-code">*</span>IP:</div>
                  <input
                    type="text"
                    :class="['e-control', 'e-textbox', 'e-lib', 'e-input']"
                    v-model="ipList[index]"
                    placeholder="IP"
                    name="ipCheck"
                    @blur="ipCheckBulr"
                  />
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import common from "../common";
import { EventBus } from "../../../../../plugins/eventBus";

export default {
  name: "Son_UPFCheckBox",
  props: ["data", "opCode"],
  mixins: [common],
  data() {
    return {
      params: {
        name: this.data.name,
        paramVal: this.data.value
      },
      text: [
        "h-subscriber-inputBoxDiv",
        "h-subscriber-inputBoxDivInPartten1",
        "h-subscriber-inputBoxDivInPartten2"
      ],
      checkBoxArr: [],
      aliasList: [],
      ipList: [],
      checkAllFlag: true,
      show: "show",
      checkId: "checkId;",
      validateStatusAlias: false,
      validateStatusIp: false
    };
  },
  methods: {
    aliasCheckBulr(event) {
      //input bulr validate alias
      const reg = /^(^\S)/;
      if (!reg.test(event.target.value)) {
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("Topo.noEmptyStart")
        });
        return false;
      }
    },
    ipCheckBulr(event) {
      //input bulr validate ip
      const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
      if (!reg.test(event.target.value)) {
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("NSMF.ipCheck")
        });
        return false;
      }
    },
    checkAll() {
      this.data.options.forEach(item => {
        this.checkBoxArr[item.value] = this.checkAllFlag;
      });
      if (this.checkBoxArr[0]) {//when checkall style show or display input of alais and ip
        for (var i = 0; i < this.checkBoxArr.length; i++) {
          document.getElementById("show" + i).style.display = "block";
        }
      } else {
        for (var i = 0; i < this.checkBoxArr.length; i++) {
          document.getElementById("show" + i).style.display = "none";
        }
      }
      this.$checkBoxFuncOper(true);
    },
    changeStyle() {
      //when check one style change
      let checkedDom = document.querySelectorAll(
        `#upfCheckedId [aria-checked=true] input`
      );
      let checkedDomUnCheck = document.querySelectorAll(
        `#upfCheckedId [aria-checked=false] input`
      );
      for (var i = 0; i < checkedDom.length; i++) {
        const indexcheckedDom = checkedDom[i].id.split(";")[1];
        document.getElementById("show" + indexcheckedDom).style.display =
          "block";
      }

      for (var j = 0; j < checkedDomUnCheck.length; j++) {
        const indexcheckedDomUnCheck = checkedDomUnCheck[j].id.split(";")[1];
        document.getElementById("show" + indexcheckedDomUnCheck).style.display =
          "none";
      }
    },
    caculateChecks(event) {
      // checkbox 绑定事件
      this.changeStyle();

      if (this.checkBoxClickFunc !== undefined) {
        try {
          if (this.checkBoxClickFunc.get("all") !== undefined) {
            const _funcArr = this.checkBoxClickFunc.get("all");
            if (typeof _funcArr === "function") {
              _funcArr();
            } else {
              if (event.checked === false) {
                _funcArr[0]();
              } else {
                _funcArr[1]();
              }
            }
          } else {
            const _funcArr = this.checkBoxClickFunc.get(
              parseInt(event.event.target.attributes.bitVal.nodeValue)
            );
            if (_funcArr !== undefined) {
              if (typeof _funcArr === "function") {
                _funcArr();
              } else {
                if (event.checked === false) {
                  _funcArr[0]();
                } else {
                  _funcArr[1]();
                }
              }
            }
          }
        } catch (e) {
          console.log("checkbox bind Func error!!!");
        }
      }
      this.checkAllFlag = true;
      this.data.options.forEach(item => {
        if (this.checkBoxArr[item.value] === false) {
          this.checkAllFlag = false;
          return false;
        }
        return true;
      });
    },
    getParams() {
      console.log(this.getParam("value"));
    },
    setData(data = this.params.paramVal) {
      this.params.paramVal = data;
      const $this = this;
      let maxLength = 0;
      $this.data.options.forEach(item => {
        if (maxLength < item.value) maxLength = item.value;
      });
      for (let i = 0; i <= maxLength; i++) {
        this.checkBoxArr[i] = false;
      }
      let binaryVal = parseInt(this.params.paramVal).toString(2);
      binaryVal = binaryVal
        .split("")
        .reverse()
        .join("");
      for (let i = binaryVal.length; i <= maxLength; i++) {
        binaryVal += "0";
      }
      for (let i = 0; i <= maxLength; i++) {
        if (binaryVal[i] === "1") this.checkBoxArr[i] = true;
      }
      this.checkAllFlag = true;
      this.data.options.forEach(item => {
        if (this.checkBoxArr[item.value] === false) {
          this.checkAllFlag = false;
          return false;
        }
        return true;
      });
      this.$forceUpdate();
    },
    checkValidateAliasAndIp() {//parseform use all alias,ip validate result
      let aliasNewListArray = [];
      let ipNewListArray = [];
      this.checkBoxArr.forEach((item, index) => {
        if (item === true) {
          aliasNewListArray.push(this.aliasList[index]);
          ipNewListArray.push(this.ipList[index]);
        }
      });

      for (let i = 0; i < aliasNewListArray.length; i++) {//validate alais
        const aliasOne = aliasNewListArray[i];
        const reg = /^(^\S)/;
        if (aliasOne == "" || aliasOne == undefined) {
          EventBus.$emit("toast", {
            type: "warning",
            content: this.$t("NSMF.aliasNoEmpty")
          });
          this.validateStatusAlias = true;
          break;
        } else if (
          undefined != aliasOne &&
          "" != aliasOne &&
          !reg.test(aliasOne)
        ) {
          this.validateStatusAlias = true;

          EventBus.$emit("toast", {
            type: "warning",
            content: this.$t("NSMF.noEmptyStart")
          });
          break;
        } else {
          this.validateStatusAlias = false;
        }
      }
      for (let k = 0; k < ipNewListArray.length; k++) {//validate ip
        const ipOne = ipNewListArray[k];
        const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;

        if (ipOne == "" || ipOne == undefined) {
          EventBus.$emit("toast", {
            type: "warning",
            content: this.$t("NSMF.ipNoEmpty")
          });
          this.validateStatusAlias = true;
          break;
        } else if (undefined != ipOne && "" != ipOne && !reg.test(ipOne)) {
          this.validateStatusIp = true;

          EventBus.$emit("toast", {
            type: "warning",
            content: this.$t("NSMF.ipCheck")
          });
          break;
        } else {
          this.validateStatusIp = false;
        }
      }
      if (this.validateStatusAlias == true || this.validateStatusIp == true) {
        //the result validate fail
        return false;
      }
      return true;
    },
    getData() {
      this.params.paramVal = 0;
      let aliasNewList = "";
      let ipNewList = "";
      this.checkBoxArr.forEach((item, index) => {
        if (item === true) {
          this.params.paramVal += Math.pow(2, index);
          aliasNewList = aliasNewList + ";" + this.aliasList[index];//upf alais and ip input nodeselect
          ipNewList = ipNewList + ";" + this.ipList[index];
        }
      });
      const bitValue = this.params.paramVal;
      this.params.paramVal = bitValue + ":" + aliasNewList + ":" + ipNewList;
      console.log("upf this.params", this.params);
      return this.params;
    },

    $checkBoxFuncOper(_checkAllFlag = false) {
      const $this = this;
      if (_checkAllFlag) {
        const _checkFlag = this.checkAllFlag === true ? 1 : 0;
        if ($this.checkBoxClickFunc.get("all") !== undefined) {
          // more one checkbox ,need change checkBoxClickFunc name
          const _value = $this.checkBoxClickFunc.get("all");
          if (typeof _value === "function") {
            _value();
          } else {
            _value[_checkFlag]();
          }
        } else {
          for (const [_key, _value] of $this.checkBoxClickFunc) {
            if ($this.$refs[_key] !== undefined) {
              if (typeof _value === "function") {
                _value();
              } else {
                _value[_checkFlag]();
              }
            }
          }
        }
      } else {
        if ($this.checkBoxClickFunc.get("all") !== undefined) {
          const _value = $this.checkBoxClickFunc.get("all");
          if (typeof _value === "function") {
            _value();
          } else {
            if ($this.$refs[_key][0].checked === true) {
              _value[1]();
            } else {
              _value[0]();
            }
          }
        } else {
          for (const [_key, _value] of $this.checkBoxClickFunc) {
            if ($this.$refs[_key] !== undefined) {
              if (typeof _value === "function") {
                _value();
              } else {
                if ($this.$refs[_key][0].checked === true) {
                  _value[1]();
                } else {
                  _value[0]();
                }
              }
            }
          }
        }
      }
    }
  },
  beforeMount() {
    const $this = this;
    if ($this.data === undefined || $this.data.type === undefined) return;
    this.setData();
  },
  mounted() {
    setTimeout(this.$checkBoxFuncOper, 0);
  },
  created() {
    this.$parseInitData();
  }
};
</script>

<style scoped>
</style>
